import { environment } from '../../../environments/environment';

export class EnvUtils {
  public static getServerDomain(): string {
    return environment.serverDomain;
  }

  public static getBookingDomain(): string {
    return environment.bookingDomain;
  }

  public static getEncryptionPassphrase(): string {
    return environment.encryptionPassphrase;
  }

  public static getIframeModeKey(): string {
    return environment.iframeModeKey;
  }

  public static getGoogleApiKey(): string {
    return environment.googleApiKey;
  }

  public static getGoogleTagManagerId(): string {
    return environment.googleTagManagerId;
  }

  public static isProduction(): boolean {
    return environment.production;
  }

  public static isEnableServiceWorker(): boolean {
    return environment.enableServiceWorker;
  }
}
